export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crypto ID:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Język"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzień dobry"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzień dobry"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dobry wieczór"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dobranoc"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyloguj się"])}
}